import { createSelector } from 'reselect';

export const selectedRejectedClaims = (state: any) => {
  return state.get('preOpenManagerRejectedClaims');
};

const makeSelectRejectedClaims = () =>
  createSelector(selectedRejectedClaims, claims => {
    if (claims && claims.get('claims')) {
      return claims.get('claims').toJS();
    }
    return [];
  });

const makeSelectCountRejectedClaims = () =>
  createSelector(selectedRejectedClaims, claims => {
    if (claims && claims.get('countClaims')) {
      return claims.get('countClaims');
    }
    return 0;
  });

export { makeSelectRejectedClaims, makeSelectCountRejectedClaims };
